import { useEffect } from 'react';

export const useTabViewBorderRadius = () => {
    useEffect(() => {
        const updateTabViewBorderRadius = () => {
            // Znajdź wszystkie TabView na stronie
            const tabViews = document.querySelectorAll('.p-tabview');
            
            tabViews.forEach(tabView => {
                const panels = tabView.querySelector('.p-tabview-panels');
                const firstTab = tabView.querySelector('.p-tabview-nav li:first-child');
                
                if (panels && firstTab) {
                    // Sprawdź czy pierwsza zakładka jest aktywna
                    const isFirstTabActive = firstTab.classList.contains('p-highlight');
                    
                    if (isFirstTabActive) {
                        panels.style.setProperty('border-top-left-radius', '0px', 'important');
                        //console.log('Setting border-top-left-radius: 0px for TabView', tabView);
                    } else {
                        panels.style.setProperty('border-top-left-radius', '16px', 'important');
                        //console.log('Setting border-top-left-radius: 16px for TabView', tabView);
                    }
                }
            });
        };

        // Wykonaj natychmiast
        updateTabViewBorderRadius();

        // Obserwuj zmiany w DOM - bardziej precyzyjnie
        const observer = new MutationObserver((mutations) => {
            let shouldUpdate = false;
            
            mutations.forEach((mutation) => {
                // Sprawdź czy zmiana dotyczy klasy p-highlight
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const target = mutation.target;
                    if (target.classList.contains('p-highlight') || 
                        target.classList.contains('p-tabview-nav-link') ||
                        target.closest('.p-tabview-nav')) {
                        shouldUpdate = true;
                    }
                }
                
                // Sprawdź czy dodano/usunięto elementy TabView
                if (mutation.type === 'childList') {
                    const addedNodes = Array.from(mutation.addedNodes);
                    const removedNodes = Array.from(mutation.removedNodes);
                    
                    const hasTabViewChanges = [...addedNodes, ...removedNodes].some(node => {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            return node.classList?.contains('p-tabview') || 
                                   node.querySelector?.('.p-tabview') ||
                                   node.closest?.('.p-tabview');
                        }
                        return false;
                    });
                    
                    if (hasTabViewChanges) {
                        shouldUpdate = true;
                    }
                }
            });
            
            if (shouldUpdate) {
                setTimeout(updateTabViewBorderRadius, 0);
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
        });

        // Obserwuj zmiany zakładek przez event listener
        const handleTabClick = (e) => {
            if (e.target.closest('.p-tabview-nav-link')) {
                setTimeout(updateTabViewBorderRadius, 50);
            }
        };

        document.addEventListener('click', handleTabClick);

        // Dodatkowo sprawdzaj co 100ms przez pierwsze 5 sekund po załadowaniu
        // let checkCount = 0;
        // const interval = setInterval(() => {
        //     updateTabViewBorderRadius();
        //     checkCount++;
        //     if (checkCount >= 50) { // 5 sekund
        //         clearInterval(interval);
        //     }
        // }, 100);

        // return () => {
        //     observer.disconnect();
        //     document.removeEventListener('click', handleTabClick);
        //     clearInterval(interval);
        // };
    }, []);
};
